import { clientApi } from './CLIENT';

const url = '/api/dashboard/auth/login';
// eslint-disable-next-line no-return-await
export default async (body) => await clientApi().post(url, JSON.stringify(body)).then((data) => data);
